var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormulateForm",
    { ref: "form", attrs: { name: "form" } },
    [
      _c("e-sidebar", {
        attrs: {
          id: "sidebar-stock-counting-rule",
          title: _vm.isEdit
            ? _vm.$t("Editar Regra de Contagem")
            : _vm.$t("Nova Regra de Contagem"),
          show: _vm.showSidebar,
          fetching: _vm.fetching,
          saving: _vm.saving,
          width: "500px",
        },
        on: {
          save: _vm.onSaveRule,
          hidden: function ($event) {
            _vm.showSidebar = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "rule-group-id",
                            label: _vm.$t("Grupo"),
                            type: "vue-select",
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.groupOptions,
                          },
                          model: {
                            value: _vm.ruleForm.groupId,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "groupId", $$v)
                            },
                            expression: "ruleForm.groupId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "rule-brand-id",
                            label: _vm.$t("Marcas"),
                            type: "vue-select",
                            multiple: true,
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.brandOptions,
                          },
                          model: {
                            value: _vm.ruleForm.brandIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "brandIds", $$v)
                            },
                            expression: "ruleForm.brandIds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "rule-day-of-week",
                            type: "vue-select",
                            multiple: true,
                            label: _vm.$t("Dias da semana"),
                            placeholder: _vm.$t("Selecione"),
                            options: _vm.stockCountingDayOfWeekOptions(),
                            validation: "required",
                          },
                          model: {
                            value: _vm.ruleForm.daysOfWeek,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "daysOfWeek", $$v)
                            },
                            expression: "ruleForm.daysOfWeek",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          staticClass: "required",
                          attrs: {
                            id: "rule-min-countings",
                            type: "text-number",
                            precision: 0,
                            label: _vm.$t("Mín. contagens obrigatórias"),
                            validation: "required|min:1",
                          },
                          model: {
                            value: _vm.ruleForm.minCountings,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleForm,
                                "minCountings",
                                _vm._n($$v)
                              )
                            },
                            expression: "ruleForm.minCountings",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "rule-active",
                            type: "switch",
                            label: _vm.$t("Ativo"),
                          },
                          model: {
                            value: _vm.ruleForm.active,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "active", $$v)
                            },
                            expression: "ruleForm.active",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c("FormulateInput", {
                          attrs: {
                            id: "rule-description",
                            type: "textarea",
                            label: _vm.$t("Descrição"),
                          },
                          model: {
                            value: _vm.ruleForm.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "description", $$v)
                            },
                            expression: "ruleForm.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }